// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

var jQuery = require('jquery')
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"


import Swal from 'sweetalert2'
window.Swal = Swal

//= require pace/pace

global.Rails = Rails


global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

import 'bootstrap'


var title_msg= "";
var confirm_msg= "";
var cancel_msg= "";

if(gon.locale == "ar"){
  title_msg = "هل انت متأكد؟";
  confirm_msg = "نعم, قم بالحذف";
  cancel_msg = "لا";
}else{
  title_msg = "Are you sure?";
  confirm_msg = "Yes, delete it!";
  cancel_msg = "No";
}


window.replaceQueryParam = function(param, newval, search) {
  var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
  var query = search.replace(regex, "$1").replace(/&$/, '');

  return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
}

window.goto = function(url){
  window.location = url
}


Rails.confirm = function(message, element) {
  let $element = $(element)

  // Prefer reading raw attributes (most reliable across Rails UJS + jQuery behaviors)
  let titleOverride = element && element.getAttribute && element.getAttribute('data-confirm-title')
  let confirmOverride = element && element.getAttribute && element.getAttribute('data-confirm-button')
  let cancelOverride = element && element.getAttribute && element.getAttribute('data-cancel-button')

  // Fallback to jQuery's data() in case attributes were set dynamically
  titleOverride = titleOverride || $element.data('confirmTitle')
  confirmOverride = confirmOverride || $element.data('confirmButton')
  cancelOverride = cancelOverride || $element.data('cancelButton')
  Swal.fire({
    title: titleOverride || title_msg,
    text: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: cancelOverride || cancel_msg,
    confirmButtonText: confirmOverride || confirm_msg
    }).then((result) => {
    if (result.isConfirmed) {
      let old = Rails.confirm
      Rails.confirm = function() { return true }
      $element.get(0).click();
      Rails.confirm = old;
    }
  });
  return false;
}



Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "controllers"
